import Link from "next/link";
import { AiOutlineQuestionCircle } from "react-icons/ai";
import { FaInstagram, FaWhatsapp } from "react-icons/fa";
import { FiInfo, FiList, FiLogIn } from "react-icons/fi";

import Logo from "./logo";
import MobileMenu from "./mobile-menu";

export default function Header() {
  return (
    <header className='bg-white absolute top-12 w-full z-30'>
      <div className='max-w-6xl mx-auto px-4 sm:px-6'>
        <div className='flex items-center justify-between h-16 md:h-20'>
          {/* Site branding */}
          <div className='flex items-center flex-1'>
            <Logo />
            <Link
              href='/'
              className='ml-1 text-sm md:text-lg whitespace-nowrap text-gray-700 font-semibold inline-block md:hidden lg:inline-block'
            >
              Rota Lounge
            </Link>
          </div>

          {/* Desktop navigation */}
          <nav className='hidden md:flex md:grow'>
            {/* Desktop menu links */}
            <ul className='flex grow justify-center flex-wrap items-center'>
              <li>
                <Link
                  href='https://www.instagram.com/rotalounge/'
                  className='flex items-center font-medium text-base text-gray-700 hover:text-purple-600 mx-4 lg:mx-5 transition duration-150 ease-in-out'
                >
                  <FaInstagram className='mr-1' /> Instagram
                </Link>
              </li>
              <li>
                <Link
                  href='https://api.whatsapp.com/send?phone=5511940590576&text=Ol%C3%A1%20quero%20saber%20mais%20sobre%20a%20Rota%20Lounge'
                  className='flex items-center font-medium text-base text-gray-700 hover:text-purple-600 mx-4 lg:mx-5 transition duration-150 ease-in-out'
                >
                  <FaWhatsapp className='mr-1' /> WhatsApp
                </Link>
              </li>
              <li>
                <Link
                  href='/#about'
                  className='flex items-center font-medium text-base text-gray-700 hover:text-purple-600 mx-4 lg:mx-5 transition duration-150 ease-in-out'
                >
                  <FiInfo className='mr-1' /> Sobre
                </Link>
              </li>
              <li>
                <Link
                  href='/#plans'
                  className='flex items-center font-medium text-base text-gray-700 hover:text-purple-600 mx-4 lg:mx-5 transition duration-150 ease-in-out'
                >
                  <FiList className='mr-1' /> Planos
                </Link>
              </li>
              <li>
                <Link
                  href='/faq'
                  className='flex items-center font-medium text-base text-gray-700 hover:text-purple-600 mx-4 lg:mx-5 transition duration-150 ease-in-out'
                >
                  <AiOutlineQuestionCircle className='mr-1' /> FAQ
                </Link>
              </li>
            </ul>
          </nav>

          {/* Existing Desktop sign in links */}
          <ul className='flex-1 flex justify-end items-center'>
            <li className='ml-3'>
              <Link
                href='https://app.rotalounge.com.br/login'
                className='btn-sm text-white transition duration-150 ease-in-out w-full group relative before:absolute before:inset-0 before:bg-slate-800/30 before:rounded-full before:pointer-events-none [background:linear-gradient(theme(colors.slate.900),theme(colors.slate.900))_padding-box,conic-gradient(theme(colors.slate.400),theme(colors.slate.700)_25%,theme(colors.slate.700)_75%,theme(colors.slate.400)_100%)_border-box] hover:before:bg-purple-600/30'
              >
                <span className='relative inline-flex items-center'>
                  <FiLogIn className='mr-1' /> Login
                </span>
              </Link>
            </li>
          </ul>

          <MobileMenu />
        </div>
      </div>
    </header>
  );
}
